import { FormControl, FormControlLabel, Switch } from '@mui/material';
import React from 'react';

export function CustomSwitch({ children, ...props }: any) {
    return (
        <FormControl>
            <FormControlLabel
                sx={{
                    paddingLeft: '5px',
                    paddingTop: '5px',
                }}
                control={
                    <Switch
                        size='small'
                        sx={{ paddingTop: '5px' }}
                        {...props}
                    />
                }
                label={props.label}
            />
        </FormControl>
    );
}
